import { useProjectContext } from "@contexts/projects";
import IndicatorCard from "./IndicatorCard";
import { cardTexts } from "@utils/cardTexts";
import { checkIfMultipleIds } from "@utils/checkMultipleIds";
import { useAuthContext } from "@contexts/auth";
import { usePlanBasis } from "@utils/planBasis";
import { combineMetricEnvelopes } from "@utils/metricPresentation";
import { Fragment } from "react";

const Indicators = () => {
  const { activeProject: { indicator }, activeProject } = useProjectContext();
  const { user: { configurations: { dashboard: { cards: { graph } } } } } = useAuthContext();
  const { basis, idpValue } = usePlanBasis();
  const idpTooltip = basis === 'forecast' ? cardTexts.IDP_FORECAST : basis === 'base' ? cardTexts.IDP : cardTexts.IDP_NO_PLAN;
  const scheduleSource = activeProject?.scheduleSource;
  const sourceLabel = scheduleSource?.source === "prevision" ? "Prevision"
    : scheduleSource?.source === "sienge" ? "Sienge"
      : scheduleSource?.source === "mega" ? "MEGA" : null;
  const conditionLabel = scheduleSource?.condition === "fallback_last_valid"
    ? ", último snapshot válido"
    : scheduleSource?.condition === "fallback_erp"
      ? ", fallback ERP"
      : "";
  const sourceSuffix = sourceLabel ? ` (curvas: ${sourceLabel}${conditionLabel})` : "";

  const checkCard = (i) => {
    switch (i) {
      case 'indexTrend':
        return <IndicatorCard
          title="Orçado Indexado/ Tendência"
          tooltip={cardTexts.TREND_BUDGETED}
          reasonId="metric-indexed-budget-trend-reason"
          envelope={activeProject.metrics?.ioit}
        />
      case 'idc':
        if (checkIfMultipleIds()) return
        return <IndicatorCard title="IDC" tooltip={cardTexts.IDC} envelope={activeProject.metrics?.idc} />
      case 'apropriated':
        if (checkIfMultipleIds()) return
        return <IndicatorCard title="Pagamentos apropriados" tooltip={cardTexts.APPROPRIATED} black indicator={indicator?.ipa} />
      case 'idp':
        if (checkIfMultipleIds()) return
        return <IndicatorCard title="IDP" tooltip={idpTooltip + sourceSuffix} indicator={idpValue} />
      case 'apr_compr': {
        if (checkIfMultipleIds()) return
        const envelope = combineMetricEnvelopes(
          [activeProject.metrics?.attended_total, activeProject.metrics?.committed],
          ([attended, committed]) => committed !== 0 ? attended / committed : null,
          { id: "apr_compr", unit: "ratio" },
        );
        return <IndicatorCard title="Pagamentos apropriados / Comprometido" tooltip={cardTexts.APR_COMPR} black envelope={envelope} />
      }
      default:
        break;
    }
  }

  return (
    <div>
      <div className="grid columns-3 columns-1-laptop gap-16">
        {graph.map(i => {
          return <Fragment key={i}>{checkCard(i)}</Fragment>
        })}
      </div>
    </div>
  )
}

export default Indicators;
